<template>
  <el-collapse v-model="activeNames" class="registerCollapse flex flex-col items-stretch justify-start gap-2">
    <el-collapse-item v-for="list in lists" :key="list.name" :name="list.name">
      <template #title>
        <div
          :class="activeNames.includes(list.name) ? 'bg-opacity-15' : 'bg-opacity-5'"
          class="flex items-center justify-between p-3 w-full rounded text-xs text-darkBlueG0 font-semibold leading-none bg-blueG0 hover:bg-opacity-15"
        >
          {{ $t(list.title) }}
          <i
            :class="activeNames.includes(list.name) ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            class="text-base text-black leading-none"
          />
        </div>
      </template>
      <div class="px-3 pt-3 pb-2 text-darkBlueG0 text-xs leading-none whitespace-pre-line">
        <component v-if="list.slot" :is="list.slot" />
        <div v-else>{{ $t(list.desc) }}</div>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
export default {
  name: 'RegisterCollapse',
  props: {
    // Array<{ name: '1',title:'', desc: '', slot: <Component />? }>
    lists: { type: Array, required: true }
  },
  data() {
    return {
      activeNames: []
    };
  },
  mounted() {
    if (this.lists.length > 0 && this.lists[0]?.name) {
      this.activeNames = [this.lists[0]?.name];
    }
  }
};
</script>

<style lang="scss" scoped>
.registerCollapse.el-collapse ::v-deep {
  padding: 0;
  border: 0;
  box-shadow: none;

  .el-collapse-item__header {
    border: 0;
    height: auto;
    background: transparent;
  }

  .el-collapse-item__content {
    padding: 0;
  }
  .el-collapse-item__arrow {
    display: none;
  }

  .el-collapse-item__wrap {
    border: 0;
  }
}
</style>
